import type { SupabaseClient } from '@supabase/supabase-js';
import type { DBNotification } from '@/types/types';

export async function getActiveNotifications(client: SupabaseClient, userId: string): Promise<DBNotification[]> {
    const { data, error } = await client
        .from('notifications')
        .select('*')
        .eq('user_id', userId)
        .is('dismissed_at', null)
        .order('created_at', { ascending: false });
    if (error) { console.error('[notifications] fetch error:', error.message); return []; }
    return (data || []) as DBNotification[];
}

export async function dismissNotification(client: SupabaseClient, userId: string, notificationKey: string): Promise<void> {
    await client
        .from('notifications')
        .update({ dismissed_at: new Date().toISOString() })
        .eq('user_id', userId)
        .eq('notification_key', notificationKey);
}

export async function dismissAllNotifications(client: SupabaseClient, userId: string): Promise<void> {
    await client
        .from('notifications')
        .update({ dismissed_at: new Date().toISOString() })
        .eq('user_id', userId)
        .is('dismissed_at', null);
}

export async function deleteNotificationByKey(client: SupabaseClient, userId: string, notificationKey: string): Promise<void> {
    await client
        .from('notifications')
        .delete()
        .eq('user_id', userId)
        .eq('notification_key', notificationKey);
}
